import { jsx } from "panel";
import { DropMenuEl } from "common/components/drop-menu";
import { Directions } from "common/components/drop-menu/types";
import { CreateAnnotationFormEl } from "./create-annotation-form";
import { ViewAnnotationsListEl } from "./view-annotations-list";
export function AnnotationsMixin() {
  const { annotations } = this.state;
  return annotations.activeAnnotationButton ? /* @__PURE__ */ jsx(DropMenuEl, {
    sel: ".line-chart-annotation-popup",
    attrs: {
      open: !annotations.activeAnnotationPopupClosing,
      direction: Directions.CenterUp,
      "allowed-flip-directions": [Directions.UpRight]
    },
    on: {
      change: this.helpers.annotations.popupChange
    },
    props: {
      positionParent: annotations.activeAnnotationButton.element
    },
    key: `annotation-popup-${annotations.activeAnnotationButton.timestampMs}`
  }, annotations.creatingAnnotation ? /* @__PURE__ */ jsx(CreateAnnotationFormEl, {
    key: annotations.createAnnotationDate,
    attrs: {
      elref: `createAnnotationForm`,
      "utc-offset": this.attr(`utc-offset`),
      date: annotations.createAnnotationDate
    },
    on: {
      annotationCreated: this.helpers.annotations.add,
      closeAnnotationPopup: this.helpers.annotations.close
    }
  }) : annotations.viewingAnnotations ? /* @__PURE__ */ jsx(ViewAnnotationsListEl, {
    attrs: {
      elref: `viewAnnotationsList`,
      "active-annotation": annotations.activeAnnotationButton,
      "active-annotation-group": annotations.visibleAnnotations.get(
        annotations.activeAnnotationButton.timestampMs
      ),
      "annotation-description-draft": annotations.annotationDescriptionDraft,
      "can-write-annotations": this.attr(`show-annotations`),
      "editing-annotation": annotations.editingAnnotation,
      "deleting-annotation": annotations.deletingAnnotation,
      "time-unit": this.attr(`time-unit`)
    },
    on: {
      closeAnnotationPopup: this.helpers.annotations.close,
      showCreateAnnotation: this.helpers.annotations.showCreate,
      editAnnotation: this.helpers.annotations.edit,
      deleteAnnotation: this.helpers.annotations.delete,
      updateAnnotationDescriptionDraft: this.helpers.annotations.updateDescriptionDraft,
      saveAnnotation: this.helpers.annotations.save,
      editCanceled: this.helpers.annotations.editCanceled,
      deleteConfirmed: this.helpers.annotations.deleteConfirmed,
      deleteCanceled: this.helpers.annotations.deleteCanceled
    }
  }) : null) : annotations.activeAnnotationPreview ? /* @__PURE__ */ jsx(DropMenuEl, {
    sel: ".line-chart-annotation-popup",
    attrs: {
      open: true,
      direction: Directions.CenterUp
    },
    props: {
      positionParent: annotations.activeAnnotationPreview.element
    },
    key: `annotation-preview-${annotations.activeAnnotationPreview.timestampMs}`
  }, /* @__PURE__ */ jsx(ViewAnnotationsListEl, {
    attrs: {
      elref: `viewAnnotationsList`,
      "active-annotation": annotations.activeAnnotationPreview,
      "active-annotation-group": annotations.visibleAnnotations.get(
        annotations.activeAnnotationPreview.timestampMs
      ),
      "time-unit": this.attr(`time-unit`),
      type: `preview`
    }
  })) : null;
}
